module.exports = __webpack_public_path__ + "img/azxbo-u1ybj.c92c2946.png";